<div *ngIf="!success">
  <h1 class="text-2xl md:text-3xl font-bold text-gray-900">Reset your password</h1>
  <p class="text-gray-500 mt-1 mb-8">Enter your email and follow the instructions in your inbox.</p>

  <form [formGroup]="resetForm">
    <div class="dm-input">
      <label>Email address</label>
      <input formControlName="email" type="text" placeholder="you@company.com">
      <small class="red" *ngIf="email.touched && email.invalid">Must be a valid email</small>
    </div>

    <button class="btn btn-primary w-full" (click)="onReset()" type="button" *ngIf="!processing">Reset password</button>
    <button class="btn btn-processing w-full" disabled *ngIf="processing" type="button">
      <i class="fas fa-circle-notch"></i>
      Sending...
    </button>

    <p class="text-sm text-gray-500 mt-6 text-center">
      <span class="mr-1">Already have a password?</span>
      <a class="basic-link font-medium" routerLink="../login">Login</a>
    </p>

    <app-warning-message type="error" title="Sign in failed" message="Wrong email or password."
                          *ngIf="authSvc.invalidEmail || authSvc.wrongCredentials || authSvc.userNotFound"></app-warning-message>
    <app-warning-message type="error" title="Too many attempts" message="We have detected too many failed attempts. Wait a few minutes and try again."
                          *ngIf="authSvc.tooManyRequests"></app-warning-message>
    <app-warning-message type="error" title="Something went wrong" [message]="authSvc.unknownError"
                          *ngIf="authSvc.unknownError"></app-warning-message>
  </form>
</div>

<div *ngIf="success" class="text-center">
  <i class="fas fa-check-circle text-green-500 text-3xl mb-4"></i>
  <h1 class="text-2xl font-bold text-gray-900 mb-2">Check your inbox</h1>
  <p class="text-gray-500 mb-8">We've sent password reset instructions to your email. Remember to check spam if you don't see it.</p>
  <a class="basic-link font-medium" routerLink="../login">Back to login</a>
</div>
